// Tag raw data with orgId
export function withOrg<T>(orgId: string, items: T[]): (T & { orgId: string })[] {
  return items.map((item) => ({ ...item, orgId }));
}

// Filter combined data by selected org
export function filterByOrg<T extends { orgId: string }>(
  items: T[],
  selectedOrgId: string,
): T[] {
  return items.filter((item) => item.orgId === selectedOrgId);
}

export const DEF_JAM_ORG_ID = 'org-3';
export const PERSONAL_ORG_ID = 'demo-personal';
